/* eslint-disable */

export default function() {
  const logging = true;
  let enabled = process.env.VUE_APP_GAMEPAD_ENABLED === "true";
  let activated = process.env.VUE_APP_GAMEPAD_AUTO_ACTIVATE === "true";
  let pointer = null;
  let activateTimeout = 50;


  // Functions associated with buttons:
  const Buttons = document.gamepad.buttons;
  const Actions = [
    {
      ids: [Buttons.BUTTON_A],
      press: () => {
        command("pad-a-press");
      },
      release: () => {
        command("pad-a");
      },
    },
    {
      ids: [Buttons.BUTTON_PLAY],
      press: () => {
        command("pad-play");
      },
    },
    {
      ids: [Buttons.BUTTON_B],
      press: () => {
        command("pad-b");
      },
    },
    {
      ids: [Buttons.ARROW_UP, Buttons.LEFT_ANALOG_UP],
      press: () => {
        command("pad-up");
      },
    },
    {
      ids: [Buttons.ARROW_DOWN, Buttons.LEFT_ANALOG_DOWN],
      press: () => {
        command("pad-down");
      },
    },
    {
      ids: [Buttons.ARROW_LEFT, Buttons.LEFT_ANALOG_LEFT],
      press: () => {
        command("pad-left");
      },
    },
    {
      ids: [Buttons.ARROW_RIGHT, Buttons.LEFT_ANALOG_RIGHT],
      press: () => {
        command("pad-right");
      },
    },
  ];

  /*******************************************************************************************************
   *                                          Commands:                                                  *
   *******************************************************************************************************/

  function go(selector) {
    for (const selector of arguments) {
      if (exists(selector)) {
        return focus(selector);
      }
    }

    // Fallback if there is no element found. Check if pointer is set but is not present on screen go to start:
    if (pointer) {
      const style = window.getComputedStyle(pointer);
      if (style && style.display === "none") {
        resetFocus();
      }
    }
  }

  function run(name, param) {
    if (typeof document[name] !== "function") {
      throw new Error('Unknown function "' + name + '" in global document');
    }

    return document[name](param);
  }

  function highlight(selector, state)
  {
    if (state === 'ON') {
      document.querySelector(selector).classList.add('active');
    } else {
      document.querySelector(selector).classList.remove('active');
    }
  }

  function news(direction) {
    switch (direction) {
      case "prev":
        document.newsSlider.isPad = true;
        document.newsSlider.autofocus = false;
        document.newsSlider.previous();
        break;

      case "next":
        document.newsSlider.isPad = true;
        document.newsSlider.autofocus = false;
        document.newsSlider.next();
        break;

      default:
        throw new Error('Invalid direction, please use "prev" or "next"');
    }
  }

  function merch(direction) {
    switch (direction) {
      case "prev":
        document.merchSlider.isPad = true;
        document.merchSlider.autofocus = false;
        document.merchSlider.previous();
        break;

      case "next":
        document.merchSlider.isPad = true;
        document.merchSlider.autofocus = false;
        document.merchSlider.next();
        break;

      default:
        throw new Error('Invalid direction, please use "prev" or "next"');
    }
  }

  /*******************************************************************************************************
   *                                          App:                                                       *
   *******************************************************************************************************/

  async function leaveWebView(target) {
    try {
      target = target || 'left';
      log("Leaving webview...", target);
      await CefSharp.BindObjectAsync("launcher");
      launcher.leaveWebview(target);
      activated = false;
      document.body.classList.remove("is-gamepad");
    } catch (e) {
      console.error(e);
    }
  }

  async function enterWebView(target) {
    try {
      log("Entering webview...", target);

      // Go to target:
      switch (target) {
        case 'right':
          focus('pad-start');
          break;

        case 'none':
          focus('pad-start');
          break;

        case 'down':
          focus('#pad-account');
          break;
      }

      // Add class:
      if (document.gamepad.count > 0) {
        document.body.classList.add("is-gamepad");
      } else {
        document.body.classList.remove("is-gamepad");
      }

      // Activate pad:
      setTimeout(() => {
        activated = true;
      }, activateTimeout);
    } catch (e) {
      console.error(e);
    }
  }

  function command(name) {
    // Focus first if there is not pointer:
    if (!pointer) {
      focus();
    }

    // Search up in DOM tree parents elements to find support for attribute with command definition:
    let attribute = null;
    let toScan = pointer;

    do {
      if (toScan.attributes && typeof toScan.attributes[name] !== "undefined") {
        attribute = toScan.attributes[name];
      }
      toScan = toScan.parentNode;
    } while (toScan && attribute === null);

    // Check if attribute is callable:
    if (typeof attribute === "function") {
      return attribute();
    }

    // Parse string code:
    const code = attribute ? attribute.nodeValue : null;

    // Exit if code does not exist:
    if (typeof code !== "string") {
      return;
    }

    // Parse code (code can have multiple lines separated by ";"):
    const lines = code.split(";");

    // Iterate over each line of code:
    for (const line of lines) {
      // Parse single line of code, format is: COMMAND:arg1,arg2,arg3...
      const parsed = line.split(":");
      const command = parsed[0];
      const args = parsed[1] ? parsed[1].split(",") : [];

      //log("=======================================================");
      //log("Command: " + command, "on", pointer, args);

      // Dispatch:
      switch (command) {
        case "go":
          go.apply(pointer, args);
          break;

        case "run":
          console.log('RUN', args);
          run.apply(pointer, args);
          break;

        case "highlight":
          highlight.apply(pointer, args);
          break;

        case "click":
          click.apply(pointer, args);
          break;

        case "news":
          news.apply(pointer, args);
          break;

        case "merch":
          merch.apply(pointer, args);
          break;

        case "leaveWebView":
          leaveWebView.apply(pointer, args);
          break;

        default:
          console.error('Unknown command "' + command + '"');
          return;
      }
    }

    //log("OK  ...pointer on:", pointer);
  }

  function focus(selector) {
    if (!enabled) return;

    // Set pointer to give selector:
    if (typeof selector === "string") {
      pointer = document.querySelector(selector);
    }

    // If pointer is missing make sure it exists and move to start:
    if (!pointer) {
      // Take focussed element:
      //pointer = document.activeElement;

      // Otherwise get stating element:
      if (!pointer) {
        pointer = document.querySelector("[pad-start]");
      }

      // If pointer is still not present (for example html content was not loaded) - prevent throwing error:
      if (!pointer) {
        return;
      }
    }

    pointer.focus({
      preventScroll: true,
    });

    return pointer;
  }

  function resetFocus() {
    if (!enabled) return;

    focus("[pad-start]");
  }

  function clearFocus() {
    if (!enabled) return;

    pointer = null;
  }

  function exists(selector) {
    return !!document.querySelector(selector);
  }

  function click(selector) {
    focus(selector);

    setTimeout(function() {
      pointer.click();
    }, 100);
  }

  /*******************************************************************************************************
   *                                          Pad support:                                               *
   *******************************************************************************************************/

  function log() {
    if (logging) {
      console.log.apply(this, arguments);
    }
  }

  function isGamepadEnabled() {
    return enabled && activated && document.hasFocus();
  }

  function init() {
    // Make sure it is not initialized twice:
    if (typeof document.pad !== "undefined") {
      return;
    }

    // Initialize pad events:
    log("Init vue gamepad...");

    // Register external functions:
    document.pad = {
      focus: focus,
      resetFocus: resetFocus,
      clearFocus: clearFocus,
      leaveWebView: leaveWebView,
      enterWebView: enterWebView,
    };

    // Shortcuts:
    document.leaveWebView = leaveWebView;
    document.enterWebView = enterWebView;

    // Disable initialization:
    if (!enabled) {
      return;
    }

    // Init events:
    log('Attaching pad events...');

    for (const action of Actions) {
      for (const id of action.ids) {
        // Press:
        if (action.press) {
          document.gamepad.press[id] = (gamepad) => {
            if (isGamepadEnabled()) {
              action.press(gamepad);
            }
          }
        }

        // Release:
        if (action.release) {
          document.gamepad.release[id] = (gamepad) => {
            if (isGamepadEnabled()) {
              action.release(gamepad);
            }
          }
        }
      }
    }

    // Add gamepad support events:
    document.gamepad.on['connect'] = (gamepad, count) => {
      document.body.classList.add("is-gamepad");
    }
    document.gamepad.on['disconnect'] = (gamepad, count) => {
      if (count < 1) {
        document.body.classList.remove("is-gamepad");
      }
    }

    // Initialize at start because connect event might be already fired:
    // if (document.gamepad.count > 0) {
    //   document.body.classList.add("is-gamepad");
    // }

    // Register tests:
    // setInterval(() => {
    //   if (document.gamepad.count >= 0) {
    //     document.getElementById("focus").style[
    //       "background-color"
    //     ] = document.hasFocus() ? "green" : "red";
    //     document.getElementById("webview").style["background-color"] = activated
    //       ? "green"
    //       : "red";
    //     document.getElementById("pad-test").style.opacity = 100;
    //   } else {
    //     document.getElementById("pad-test").style.opacity = 0;
    //   }
    // }, 100);
  }

  // Run app:
  init();
}
